import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import Button from '../Button';
import { FlexContainer, TxtTitle } from 'components';
import { useCallback } from 'react';
import View from '../View';
import styles from './Tabs.module.scss';

/**
 * Tabs
 *
 * @return {JSX.Element}
 */
const Tabs = ({
  className,
  options,
  value,
  onChange,
  disabled,
  asNav,
  buttons,
}) => {
  // const ItemComponent = useMemo(() => (asNav ? NavLink : View), [asNav]);
  // const get

  const handleChange = useCallback((key) => () => onChange(key), [onChange]);

  const itemInnerRender = (item) => (
    <View className={styles.TextWrap}>
      <TxtTitle xx>{item.value}</TxtTitle>
    </View>
  );

  const itemRenderNav = useCallback(
    (item, itemInner, isDisabled) => (
      <NavLink
        key={item.key}
        to={item.path}
        className={({ isActive }) =>
          classNames(styles.Item, isActive && styles.Item__active)
        }
        disabled={isDisabled}
        replace
      >
        {itemInner}
      </NavLink>
    ),
    []
  );

  const itemRenderButton = useCallback(
    (item, itemInner, isDisabled, isActive) => (
      <Button
        key={item.key}
        className={classNames(styles.Item, isActive && styles.Item__active)}
        transparent
        disabled={isDisabled}
        onClick={handleChange(item.key)}
      >
        {itemInner}
      </Button>
    ),
    [handleChange]
  );

  const itemRender = useCallback(
    (item) => {
      const itemInner = itemInnerRender(item);

      return asNav
        ? itemRenderNav(item, itemInner, disabled)
        : itemRenderButton(item, itemInner, disabled, value === item.key);
    },
    [asNav, itemRenderNav, itemRenderButton, disabled, value]
  );

  return (
    <FlexContainer
      className={classNames(
        styles.Tabs,
        buttons && styles.Tabs__buttons,
        className,
        `${Tabs.displayName}`
      )}
    >
      {options.map(itemRender)}
    </FlexContainer>
  );
};

Tabs.displayName = 'Tabs';

export default Tabs;
